/**
 * @file This is the csrf service module
 * @copyright Andreas Horvath 2016-2024
 * @version 0.2.0
 */
import { Injectable } from '@angular/core';
import { CsrfBackendService } from '../../backend-services';
import { RequestFailure, withDeadline } from '../maintenance/failure-diagnostics';

@Injectable({
  providedIn: 'root',
})
export class CsrfService {
  private pendingRefresh?: Promise<void>;
  constructor(private csrfBackendService: CsrfBackendService) {
    void this.refreshToken();
  }

  async refreshToken() {
    try {
      await this.refreshTokenStrict();
    } catch (e) {
      console.warn('csrf token error', e);
    }
  }

  refreshTokenStrict(): Promise<void> {
    if (!this.pendingRefresh) {
      this.pendingRefresh = withDeadline(this.csrfBackendService.getToken())
        .then((token) => {
          if (typeof token !== 'string' || !token) throw new RequestFailure('CSRF');
          (window as any).csrfToken = token;
        })
        .finally(() => { this.pendingRefresh = undefined; });
    }
    return this.pendingRefresh;
  }
}
